export default __webpack_public_path__ + "static/media/phone.b7fb0e52.png";